<!--
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2025-05-14 15:36:44
 * @LastEditTime : 2025-06-23 15:12:28
 * @LastEditors  : yangxr
 * @Description  : 进销存明细
 * @FilePath     : \icps_fb\src\views\platform\ICPS\Wise\docking\accessorySheet\accessoryMaterialDetail.vue
-->
<template>
    <div class="main-container">
        <el-container>
            <el-main style="padding:10px 20px; 0">
                <div v-loading="tableLoading" :style="style">
                    <tableMain ref="tableMain" key="1" :tableData="tableData" :height="screenHeight - 20" />
                </div>
            </el-main>
        </el-container>
    </div>
</template>
  
<script>
import mixin from "@/mixins/ICPSmixin.js";
import tableMain from "./tableMain.vue";
import { queryAccessorySheetData,queryAccessorySheetDataExternal } from "@/api/docking.js";
export default {
    components: {
        tableMain,
    },
    mixins: [mixin],
    data() {
        return {
            tableData:[],
            pagesType: 0,
        };
    },
    async created() {
        const query = this.$route.query
        console.log(query)
        if(query.isIcps) {
            this.getTableData(query.code)
        } else {
            this.getTableData2(query.code)
        }
        
    },
    mounted() {
    },
    watch: {
    },
    methods: {
        //明细对账单详情获取数据
        async getTableData(code) {
            let res = await queryAccessorySheetData({sheetId:code})
            if (res.code == 1001) {
                res.data.forEach(item => {
          item['amountAll'] =Math.round(parseFloat(Number(item.manufactureAmount*1+item.productMachineAmount*1+item.noGxExpend*1) ) * 1000) / 1000
        })
                this.tableData = res.data
            }
        },
        //明细对账单详情获取数据-共享
        async getTableData2(code) {
            let res = await queryAccessorySheetDataExternal({code:code})
            if (res.code == 1001) {
                res.data.forEach(item => {
          item['amountAll'] =Math.round(parseFloat(Number(item.manufactureAmount*1+item.productMachineAmount*1+item.noGxExpend*1) ) * 1000) / 1000
        })
                this.tableData = res.data
            }
        },
    }
};
</script>
<style lang="scss" scoped>
.main-container {
    background: #fff;
}
</style>